import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditTeacher from '../../components/teachers/FormAddEditTeacher';

const CreateTeacher = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditTeacher /></WrapperSection>);
export default CreateTeacher;
